var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88771 0.317436C9.73424 0.15853 9.48102 0.154123 9.32212 0.307592C9.31879 0.310803 9.31551 0.314084 9.31227 0.317436L2.79508 6.83465L0.677882 4.71745C0.518976 4.56398 0.265758 4.56839 0.112289 4.72729C-0.0374297 4.88231 -0.0374297 5.12805 0.112289 5.28307L2.51229 7.68306C2.6685 7.83923 2.92169 7.83923 3.07788 7.68306L9.87787 0.883053C10.0368 0.729561 10.0412 0.476342 9.88771 0.317436Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.7ea3034aa055b33d966f516cd6d5bdf1.svg";
export { ForwardRef as ReactComponent };